import styled from "styled-components";
import Image from "next/image";
import {
  colors,
  spacing,
  radius,
  textStyles,
  toCSS
} from "design-system/foundation";
import { breakpoints } from "styles";

export const ContentWrapper = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  gap: ${spacing["5xl"]};
  align-items: center;
`;

export const ResultContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing["2xl"]};
  align-items: center;
`;

export const ContentImage = styled(Image)`
  width: 200px;
  height: 200px;
`;

export const ContentTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
  text-align: center;
`;

export const TextTitle = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h5)};
  color: ${colors.text.base.primary};
`;

export const TextDesc = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.body.body4Regular)};
  color: ${colors.text.base.secondary};
`;

export const PointBadge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${spacing.md};
  padding: ${spacing["xl"]} ${spacing["4xl"]};
  border-radius: ${radius.md};
  background-color: ${colors.bg.base.default};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const PointLabel = styled.span`
  ${toCSS(textStyles.caption.caption6)};
  color: ${colors.text.base.primary};
`;

export const PointValue = styled.span`
  ${toCSS(textStyles.caption.caption6)};
  color: ${colors.text.semantic.success};
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: ${radius.xs};
  padding: ${spacing.xl};
  background-color: ${colors.bg.success.secondarySoft};
`;

export const BannerText = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.body.body4Bold)};
  color: ${colors.text.semantic.success};
  text-align: center;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${spacing["2xl"]};
  padding: ${spacing.none} ${spacing["5xl"]};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;
